import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

// Último envio de cada tipo de mensagem do lead, lido do histórico que o
// próprio botão Enviar grava (leads_carteira_historico). Só marca o tipo que o
// registro identifica: PROPOSTA_ENVIADA sem `dados.tipo` (envios antigos) conta
// como Proposta Texto; e-mail e SMS de disparo não entram, porque o registro
// deles não separa o envio da proposta do envio de campanha.
const ACAO_PARA_TIPO: Record<string, string> = {
  APRESENTACAO_ENVIADA: "apresentacao",
  APRESENTACAO_CARTEIRA_ENVIADA: "apresentacao_carteira",
  RETORNO_ENVIADO: "retorno",
  FECHAMENTO_ENVIADO: "fechamento",
  PROPOSTA_ENVIADA: "proposta",
};

export function useEnviosMensagemLead(leadId: string | null | undefined) {
  return useQuery({
    queryKey: ["lead-envios-mensagem", leadId],
    enabled: !!leadId,
    staleTime: 30_000,
    queryFn: async (): Promise<Map<string, string>> => {
      const { data, error } = await supabase
        .from("leads_carteira_historico")
        .select("acao, dados, created_at")
        .eq("lead_id", leadId as string)
        .in("acao", Object.keys(ACAO_PARA_TIPO))
        .order("created_at", { ascending: false })
        .limit(200);
      if (error) throw error;
      const ultimo = new Map<string, string>();
      for (const linha of (data || []) as Array<{ acao: string; dados: { tipo?: string } | null; created_at: string }>) {
        const tipo = linha.dados?.tipo || ACAO_PARA_TIPO[linha.acao];
        if (tipo && !ultimo.has(tipo)) ultimo.set(tipo, linha.created_at);
      }
      return ultimo;
    },
  });
}
